import { render, staticRenderFns } from "./PlatformAnalytics.vue?vue&type=template&id=17a5a7ec&scoped=true"
import script from "./PlatformAnalytics.vue?vue&type=script&lang=js"
export * from "./PlatformAnalytics.vue?vue&type=script&lang=js"
import style0 from "./PlatformAnalytics.vue?vue&type=style&index=0&id=17a5a7ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a5a7ec",
  null
  
)

export default component.exports